// Copy paste this template to create a new component
// that can be put into the masonry layout!

import * as React from "react";
import { css } from "emotion";
import Card from "./Card";
import { HorizontalBar, defaults } from "react-chartjs-2";
import { labeledStatement } from "@babel/types";



const barChartOptions = {
    maintainAspectRatio: false,
    responsive: true,
    legend: {
      display: true
    },
    scales: {
      xAxes: [
        {
          display: true,
          position: "bottom",
          scaleLabel: {
            display: true,
            labelString: "Percentage of Daily Bruin"
          }
        }
      ],
    yAxes: [
      {
        ticks: {
          //set the labels to stack when they're too long
          //so they don't overflow out of the card
          callback: function(label) {
            if (/\s/.test(label)) {
              if (label.split(" ").length > 2) {
                label = label.split(" ");
                label[1] = label[0] + " " + label[1];
                label.shift();
                return label;
              } else {
                return label.split(" ");
              }
            } else {
              return label;
            }
          }
        },
        stacked: false,
        //type: 'linear',
        categoryPercentage: 0.5,
        display: true,
        scaleLabel: {
          //rotate: -45,
          display: true,
          labelString: "Transfer Status"
        }
      }
    ]
  },
  ticks: {
    autoSkip: false,
    maxRotation: 0,
    minRotation: 90
  },
  title: {
    display: false,
    text: "Transfer Status"
  }
};

interface TransferStatusProps{
  caption: Array<string>;
}

class TransferStatus extends React.Component<TransferStatusProps> {
  constructor(props: TransferStatusProps){
    super(props);
  }
  state = {
    //using this as the data
    //dummy data for testing just in case
    labels: ["Transfer student from another 4-year college", "Transfer student from a 2-year college", "Non-transfer student"],
    borderWidth: 1,
    datasets: [
      {
        label: "Editors",
        data: [0, 0, 100.0],
        //barPercentage:1.0,
        categoryPercentage: 1.0,
        //barThickness: '35',
        backgroundColor: [
          "#48A2D3","#48A2D3","#48A2D3"
        ]
      },
      {
        label: "Paid staff",
        data: [4, 4, 92],
        //barPercentage:1.0,
        categoryPercentage: 1.0,
        //barThickness: '35',
        backgroundColor: 'green'
      },
      {
        label: "Senior staff",
        data: [0, 0, 100],
        //barPercentage:1.0,
        categoryPercentage: 1.0,
        //barThickness: '35',
        backgroundColor: [
          "#F0A202", "#F0A202", "#F0A202"
        ]
      },
      {
        label: "Unpaid contributors",
        data: [2.1, 6.5, 91.4],
        //barPercentage:1.0,
        categoryPercentage: 1.0,
        //barThickness: '35',
        backgroundColor: [
          "#733B90", "#733B90","#733B90"
        ]
      }
    ]
  };

  
  render() {
    defaults.global.defaultFontColor = "#0a0a0a";
    const caption = this.props.caption;
    return (
      <Card>
        <div
          className={css`
            font-size: 30px;
            text-align: center;
            margin-bottom: 5px;
            @media (max-width: 700px) {
              font-size: 18px;
            }
          `}
        >
          Transfer representation
        </div>
        <div
          className={css`
            height: 400px;
            width: 100%;
          `}
        >
          <HorizontalBar
            data={this.state}
            options={{
              ...barChartOptions
            }}
          />
        </div>
        <div
          className={css`
            font-size: 15px;
            margin: 10px;
            color: black;
            text-align: left;
          `}
        >
            {caption}
        </div>
      </Card>
    );
  }
}

export default TransferStatus;
